export default "__VITE_ASSET__CBZjnD3Z__"